import { UserContext } from "./contexts";

/**
 * Initializes the application.
 * @param userContext User context.
 * @returns
 */
export const initializeApplication = (userContext: UserContext) => {
  console.log('Initializing application...');

  return (): Promise<void> => {
    return new Promise<void>((resolve) => {
      userContext.loadToken();


      if (userContext.isConnected) {
        userContext.refresh().subscribe({
          next: () => {
            resolve();
            userContext.setUser({
              isConnected: userContext.isConnected
            });
          },
          error: (err) => {
            console.error(err);
            resolve();
          }
        });
      }
      else {
        resolve();
      }
    });
  }
};
